export default __webpack_public_path__ + "static/media/prometheus.d16aa726.svg";